import React from 'react';
import BookingPageContent from '../components/booking/BookingPage';

const BookingPage: React.FC = () => {
  return <BookingPageContent />;
};

export default BookingPage;
